var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMeal = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.9999 36.6666C29.2047 36.6666 36.6666 29.2047 36.6666 20C36.6666 10.7952 29.2047 3.33331 19.9999 3.33331C10.7952 3.33331 3.33325 10.7952 3.33325 20C3.33325 29.2047 10.7952 36.6666 19.9999 36.6666Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3599 26.2716C29.1516 26.0633 23.3716 20.2833 21.4216 18.3333L18.3333 21.4216C20.2833 23.3716 26.0633 29.1516 26.2716 29.36C27.1249 30.2133 28.5066 30.2133 29.3599 29.36C30.2133 28.5066 30.2133 27.125 29.3599 26.2716Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7283 29.36C13.9367 29.1517 18.05 25.0384 25.605 17.4834L22.5167 14.395C14.9617 21.95 10.8483 26.0634 10.64 26.2717C9.78667 27.125 9.78667 28.5067 10.64 29.36C11.4917 30.2134 12.875 30.2134 13.7283 29.36Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.201 18.2008C30.3221 16.0796 30.6086 12.9269 28.8408 11.1592C27.073 9.39144 23.9204 9.67801 21.7992 11.7992C19.678 13.9205 19.3916 17.0731 21.1594 18.8409C22.9272 20.6086 26.0798 20.322 28.201 18.2008Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4401 18.7566L17.8668 14.33L13.3401 9.80497C13.0318 9.49497 12.5318 9.49497 12.2218 9.80331L11.8934 10.13C9.92842 12.0833 9.92342 15.2583 11.8851 17.2133L13.4401 18.7566Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMeal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/meal.fb5d8450.svg";
export { ForwardRef as ReactComponent };